const WorkflowRejectCodes = {
    0: 'Cannot disable wires API for firm - check users and accounts permissions',
    1: 'Account, firm, or bank is not IBN-Enabled',
    2: 'Wallet address is not IBN-Enabled or inactive',
    3: 'Recipient wallet address is invalid or unable to receive',
    4: 'Wallet address is invalid or unable to send',
    5: 'Rejected by network server. check logs for reject code',
    6: 'Invalid settlement ID',
    7: 'Invalid settlement modification request',
    8: 'Duplicate UUID',
    9: 'Wire API cannot be removed when user still has API connections',
    10: 'Transaction limit operation failed',
    11: 'Invalid asset DPS',
    12: 'Failed user role operation',
    13: 'Invalid cancel reason',
    14: 'Transaction limit operation failed',
    15: 'Transaction limit invalid',
    16: 'Credit risk limit operation failed',
    17: 'Credit risk limit invalid',
    18: 'Credit risk limit missing',
    19: 'Liquidity risk limit operation failed',
    20: 'Transaction type not allowed for asset',
    32: 'Success',
    33: 'Missing API connection user',
    34: 'Firm Frozen',
    35: 'Missing API connection firm',
    36: 'Not an API firm',
    37: 'Missing client ID',
    38: 'Close delete account has balance',
    39: 'Close delete account has live transaction',
    40: 'Missing Audience',
    41: 'Account has live transaction',
    42: 'Failed firm API connection',
    43: 'Not an API user',
    44: 'Duplicate user account',
    45: 'Duplicate API user',
    46: 'Firm Closed',
    47: 'Invalid address book',
    48: 'Account Deleted',
    // INFO DO NOT USE 49. Reserved for Generic Error
    // 49: 'Generic Error',
    50: 'Firm Disabled',
    51: 'Firm Locked',
    52: 'Firm Deleted',
    53: 'ACG mapped to accounts',
    54: 'Account Disabled',
    55: 'Account Locked',
    56: 'Account Frozen',
    57: 'Account Closed',
    58: 'Duplicate address book',
    59: 'Missing ACG name',
    60: 'Invalid Status',
    61: 'Missing API connection name',
    62: 'Invalid time window',
    63: 'ACG user is not ACG admin',
    64: 'Failed user API connection',
    65: 'Missing Account',
    66: 'Duplicate Address',
    67: 'Duplicate Account',
    68: 'Duplicate Firm',
    69: 'Bad Firm',
    70: 'Missing Firm',
    71: 'Approver Invalid',
    72: 'Approver is user',
    73: 'Approver not in firm',
    74: 'Already Approved',
    75: 'Missing address book',
    76: 'Missing ACG',
    77: 'Missing ACG user',
    78: 'Missing API connection',
    79: 'Admin operator expired',
    80: 'Invalid User',
    81: 'User Disabled',
    82: 'User Locked',
    83: 'User Deleted',
    84: 'User terms missing',
    85: 'Missing User',
    86: 'Invalid user role',
    87: 'Missing user account',
    88: 'Missing Deposit',
    89: 'Missing Redeem',
    90: 'Invalid Wallet',
    91: 'ACG user max ACGs exceeded',
    92: 'Blockchain status down',
    93: 'Delete user has live transaction',
    94: 'Delete firm has active API users',
    95: 'Missing source ID',
    96: 'Close delete firm has active accounts',
    97: 'Invalid Account',
    98: 'Duplicate ACG number',
    99: 'Failed API connection operation',
    100: 'Invalid firm account length',
    101: 'Failed account operation',
    102: 'Failed wallet operation',
    103: 'Failed wallet keys creation',
    104: 'Failed firm operation',
    105: 'Failed user operation',
    106: 'Invalid Amount',
    107: 'Bad sender account',
    108: 'Bad recipient account',
    109: 'Amount greater than available',
    110: 'Failed authentication provider',
    111: 'Invalid deposit exception command',
    112: 'Invalid redeem exception command',
    113: 'Deposit ack exception',
    114: 'Redeem ack exception',
    115: 'Duplicate Nickname',
    116: 'Failed address book operation',
    117: 'Missing Requester',
    118: 'Failed ACG operation',
    119: 'Failed ACG user operation',
    120: 'Failed user account operation',
    121: 'Missing ACG number',
    122: 'User role not authorized',
    123: 'Delete firm has active users',
    124: 'Email is currently in use. please enter a unique email',
    125: 'Bank API req rejected',
    126: 'Close delete firm not locked or not frozen',
    127: 'Prior deposit request for DDA in progress, please try later',
    128: 'Missing account name',
    129: 'System kill switch is on',
    130: 'Duplicate Wallet',
    131: 'FedWire connectivity error',
    132: 'FedWire submit reject',
    133: 'Firm does not have permission for FedWire',
    134: 'Account does not have permission for FedWire',
    135: 'Missing wire role',
    136: 'Invalid wire role',
    137: 'Missing firm wire data',
    138: 'Failed firm wire data operation',
    139: 'Failed AbaBic operation',
    140: 'Duplicate BbkSwiftCode',
    141: 'Missing AbaBic',
    142: 'Failed AbaFed operation',
    143: 'Duplicate AbaFed',
    144: 'Missing AbaFed',
    145: 'Failed RecipientWireBlacklist operation',
    146: 'Duplicate RecipientWireBlacklist',
    147: 'Missing RecipientWireBlacklist',
    148: 'Invalid BbkSwift code size',
    149: 'Invalid IbkSwift code size',
    150: 'Invalid aba number size',
    151: 'Missing account withdrawal data',
    152: 'Failed account wire data operation',
    153: 'Cannot disable wires API for firm - check users and accounts permissions',
    154: 'Missing account balance',
    155: 'Existing scheduled smart contract payments',
    156: 'Failed smart contract payment data operation',
    157: 'Failed smart contract payment blockchain operation',
    158: 'Invalid Date',
    159: 'Firm is not smart contract enabled',
    160: 'UserAccount is not smart contract enabled',
    161: 'UserAccount is smart contract enabled',
    162: 'Contract name already exists',
    163: 'Internal error occurred',
    164: 'Duplicate Contract',
    165: 'Bank API operation failed',
    166: 'Bank API operation rejected',
    167: 'User still enabled for wires on accounts',
    168: 'FedWire low balance',
    169: 'Invalid company code',
    170: 'Duplicate company code',
    171: 'Failed user validation operation',
    172: 'Invalid SSO user ID',
    173: 'Missing LEI',
    174: 'Liquidity facility has pending transactions',
    175: 'Invalid account type',
    176: 'Unable to delete BD account with linked accounts',
    177: 'Invalid LEI length',
    178: 'Invalid linked account',
    179: 'Maximum liquidity facility accounts in firm already reached',
    180: 'Missing Email',
    181: 'Admin must be operations admin',
    182: 'Withdrawal instruction with this description already exists',
    183: 'Missing account withdrawal relationship',
    184: 'Account withdrawal relationship already exists',
    185: 'Cannot unset the primary wallet for an account',
    186: 'Invalid or missing asset',
    187: 'Account not active',
    188: 'Invalid approval type',
    189: 'Invalid Fee',
    190: 'Invalid Quantity',
    191: 'Invalid Price',
    192: 'Linked Broker-Dealer account is closed',
    193: 'Blockchain Exception',
    194: 'Insufficient balance for transaction',
    195: 'Invalid or missing purpose',
    196: 'Transfer not allowed for the firm and asset combination',
    197: 'Order side missing or invalid',
    198: 'Missing primary account',
    199: 'Invalid order ID',
    200: 'Invalid linked order ID',
    201: 'Missing account position',
    202: 'Invalid interest session',
    203: 'No interest records',
    204: 'Liquidity facility not allowed to initiate Buy/Sell',
    205: 'Order status invalid',
    206: 'LF firm either inactive or not present',
    207: 'LF firm either has inactive or not present account',
    208: 'Invalid Order',
    209: 'Invalid Transaction',
    210: 'AML check rejected',
    211: 'Transaction does not need another AML check at this time',
    212: 'No orders available for netting',
    213: 'Last netting not complete',
    214: 'Order cancel in progress',
    215: 'Missing required fields',
    216: 'Firm not active',
    217: 'Bad Response',
    218: 'Failed Withdrawal',
    219: 'Invalid secondary API connection type',
    220: 'Missing API feature value',
    221: 'Duplicate API feature',
    222: 'Invalid secondary API connection type',
    223: 'Missing API feature',
    224: 'Duplicate API feature user',
    225: 'Invalid API connection',
    226: 'Invalid delete operation on secondary API connection',
    227: 'Attribute length is not valid',
    228: 'Invalid bank account number',
    229: 'Illegal characters in attribute',
    230: 'Invalid country code',
    231: 'Attribute must be empty',
    232: 'Webhook subscription already exists',
    233: 'Invalid webhook event type',
    234: 'Webhook subscription does not exist',
    235: 'Firm is not enabled for collateral',
    236: 'Pledgee cannot be the same as pledgor',
    237: 'Asset is not enabled for collateral',
    238: 'Pledge not found',
    239: 'Pledge is not active',
    240: 'Requester is not authorized for this operation',
    241: 'Reclaim amount exceeds pledge amount',
    242: 'Amount below minimum of 0.01',
    243: 'Firm has active pledges',
    244: 'Unable to disable collateral functionality due to pending pledges',
    245: 'Missing/Invalid field asset',
    246: 'Invalid Blockchain',
    247: 'Blockchain Transfer withdrawal execution is not supported',
    248: 'WithdrawalType cannot be changed on an existing withdrawal instruction',
    249: 'Withdrawal instruction cannot be edited while a withdrawal using it is in progress',
    250: 'Invalid State/Province Code',
    251: 'Firm has an account with an active balance or pending transaction for this asset',
    255: 'MAX_CODE'
};

export const WORLFLOW_SUCCESS_CODE = 32;

export const doesWorkflowRejectCodeExist = (code: number): boolean => code in WorkflowRejectCodes;

export const getWorkflowRejectCodeMessage = (code: number): string => WorkflowRejectCodes[code] || '';

export default WorkflowRejectCodes;